module.exports = __webpack_public_path__ + "static/media/pl.a845e3ad.webp";